import { render } from "./Demographics.vue?vue&type=template&id=10c64028"
import script from "./Demographics.ts?vue&type=script&lang=js&external"
export * from "./Demographics.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__